import { render, staticRenderFns } from "./PolicySignatureOptions.vue?vue&type=template&id=55d790b6&scoped=true&"
import script from "./PolicySignatureOptions.vue?vue&type=script&lang=ts&"
export * from "./PolicySignatureOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d790b6",
  null
  
)

export default component.exports